// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tbo-sidebar[data-v-5d1dcad2]{z-index:1}.sc-list[data-v-5d1dcad2]{gap:1px}
`, "",{"version":3,"sources":["webpack://./src/modules/tbo/components/TboSidebar.vue"],"names":[],"mappings":"AACA,8BACE,SAAU,CACX,0BAGC,OAAQ","sourcesContent":["\n.tbo-sidebar{\n  z-index: 1;\n}\n\n.sc-list {\n  gap: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
